import React from 'react';

import { notEmpty } from 'utils/ramdaAdditions';
import { intervalTemplate } from 'helpers/fieldsHelpers';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const getSalary = ({amount: {from, to}, _embedded: {currency, type}}) => {
    let result = intervalTemplate(from, to);

    result += currency.name || '';
    result += type.name ? ` (${type.name})` : '';

    return result;
}

const ApprovalProjectGeneral = ({ project }) => notEmpty(project) ? (
    <div>
        <DefinitionHeader translate='common.general' iconType='info-outline' />
        <div className='panel-view'>
            <DefinitionField translate='project.company' text={ project.company } />
            <DefinitionField translate='project.department' text={ project.departmentName } />
            <DefinitionField translate='project.budget' text={ project.budgetName } />
            <DefinitionField translate='project.reason'
                text={ project.reasonName + (project.replacingName ? ` (${project.replacingName})` : '') } />
            <DefinitionField translate='project.deadline' text={ project.deadline } />
            <DefinitionField translate='project.probation' text={ project.probation } />
            <DefinitionField translate='project.salary' text={ getSalary(project.salary) } />
            <DefinitionField translate='project.bonuses' text={ project.bonus } />
        </div>
    </div>
) : null;

export default ApprovalProjectGeneral;
